import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
// import CreateBlogModal from "../Blogs/createBlogModal";
import AddEmailRecipientModal from "./addemailrecipentModal";

const ManageBccMailTable = () => {
  const dispatch = useDispatch();
  const client = useSelector((state) => state.clients?.selectedClient?.value);
  const [data, setData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });
  const [blogsData, setBlogsData] = useState([]);

  const handlePageChange = useCallback((event) => {
    setPagination(event);
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "ID",
        header: "ID",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 150,
      },
      {
        accessorKey: "countrycode",
        header: "Country Code",
        size: 150,
      },
      {
        accessorKey: "mobile",
        header: "Mobile",
        size: 150,
      },
      {
        accessorKey: "created_at",
        header: "Created At",
        size: 150,
      },
      {
        accessorKey: "action",
        header: "Action",
        size: 150,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => rowAction(event, row),
      sx: {
        cursor: "pointer",
      },
    }),
    manualPagination: true,
    rowCount: totalCount,
    onPaginationChange: handlePageChange,
    state: { pagination },
    initialState: { density: "compact" },
    renderTopToolbarCustomActions: ({ table }) => (
      <div className="d-flex">
        <div
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn bg-primary"
            disabled={client === "ts"}
            onClick={() => {
              setModalOpen(true);
            }}
          >
            Add new email recipent
          </button>
        </div>
      </div>
    ),
  });

  const rowAction = (event, row) => {
    console.log(event, row, "row");
  };

  const toggleCreateModa = () => {
    setModalOpen(false);
  };

  return (
    <Fragment>
      <AddEmailRecipientModal isOpen={isModalOpen} toggle={toggleCreateModa} />
      <Breadcrumbs
        mainTitle="BCC email recipent list"
        parent="BCC email"
        title="BCC email recipent list"
        parentPath="manage-bcc-mail"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default ManageBccMailTable;
